import {Component, OnInit, Renderer2} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Fonttype} from '../../../model/Fonttype';
import {Fontsize} from '../../../model/Fontsize';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Pagestamp} from '../../../model/Pagestamp';
import {Stamplegend} from '../../../model/Stamplegend';
import {TemplateDesignWorkflow} from '../../../model/TemplateDesignWorkflow';
import {WorkflowService} from '../../../service/workflow.service';
import {Workflow} from '../../../model/Workflow';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {InformType} from '../../../../global/util/enum/InformType';
import {Constant} from '../../../../global/util/Constant';
import {Stampimage} from '../../../model/Stampimage';
import {Stampqrcode} from '../../../model/Stampqrcode';
import {PreviewTemplateWorkflowComponent} from '../preview-template-workflow/preview-template-workflow.component';
import {Stamptestfile} from '../../../model/Stamptestfile';
import {Contentposition} from '../../../model/Contentposition';
import {Stampdatetime} from '../../../model/Stampdatetime';
import {CloneTool} from '../../../../global/util/CloneTool';
import {PagestampState} from '../../../../global/util/PagestampState';
import {Stamplayoutfile} from '../../../model/Stamplayoutfile';
import {Dialog} from '../../../../global/util/Dialog';
import {StringUtil} from '../../../../global/util/StringUtil';
import {Participant} from '../../../model/Participant';
import {Stamprubric} from '../../../model/Stamprubric';
import {TypeSignature} from '../../../../global/util/TypeSignature';
import {TypeStampRubric} from '../../../../global/util/TypeStampRubric';
import {WorkflowType} from '../../../../global/util/WorkflowType';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-template-design-workflow',
  templateUrl: './template-design-workflow.component.html',
  styleUrls: ['./template-design-workflow.component.css']
})
export class TemplateDesignWorkflowComponent implements OnInit {
  public loading: boolean;
  public workflowReceived: Workflow;
  public designerForm: FormGroup;
  public templateDesignWorkflow = new TemplateDesignWorkflow();
  public entityName = 'TITLE.TEMPLATE-DESIGN';
  public optSelected = 0;
  private deletedStamplegends: Stamplegend[] = [];
  private deletedStampimages: Stampimage[] = [];
  private deletedStampqrcodes: Stampqrcode[] = [];
  private deletedStampdatetimes: Stampdatetime[] = [];
  private deletedStamprubrics: Stamprubric[] = [];

  public fontsizes: Fontsize[] = [];
  public fonttypes: Fonttype[] = [];
  public pagestamps: Pagestamp[] = [];
  public pagestamps4Cloud: Pagestamp[] = [];
  public pagestamps4Datetime: Pagestamp[] = [];
  public contentpositions: Contentposition[] = [];
  public participants: Participant[] = [];
  public color = 'rgba(0,0,0,1)';

  constructor(private modalService: NgbModal,
              public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private workflowService: WorkflowService,
              private translate: TranslateService,
              private renderer: Renderer2) {
    Dialog.createInstance(modalService);
    this.loadInitialData();
  }

  ngOnInit(): void {
    this.createForm();
    this.loadRequiredData();
  }

  public loadInitialData() {
    this.fontsizes = LocalStorage.getFontsizes();
    this.fonttypes = LocalStorage.getFonttypes();
    this.pagestamps = LocalStorage.getPagesstamps();
    this.pagestamps4Cloud = this.preparePagestamps4Rubric(LocalStorage.getPagesstamps());
    this.contentpositions = LocalStorage.getContentpositions();
    this.pagestamps4Datetime = this.preparePagestamps4Datetime(this.pagestamps);
  }

  public isInvalidControl(arrayName: string, index: number, controlName: string) {
    const array = this.designerForm.get(arrayName) as FormArray;
    const group = array.at(index);
    return group.get(controlName).invalid && group.get(controlName).touched;
  }

  private preparePagestamps4Datetime(pagestamps: Pagestamp[]) {
    const pagestamps4Datetime: Pagestamp[] = [];
    const data = CloneTool.doList(pagestamps);
    for (const pagestamp of data) {
      if (PagestampState.FIRST === pagestamp.id || PagestampState.LAST === pagestamp.id || PagestampState.OTHER === pagestamp.id) {
        pagestamps4Datetime.push(pagestamp);
      }
    }
    return pagestamps4Datetime;
  }

  private preparePagestamps4Rubric(pagestamps: Pagestamp[]) {
    const pagestamps4Rubric: Pagestamp[] = [];
    const data = CloneTool.doList(pagestamps);
    for (const pagestamp of data) {
      if (PagestampState.FIRST === pagestamp.id || PagestampState.LAST === pagestamp.id || PagestampState.OTHER === pagestamp.id) {
        pagestamps4Rubric.push(pagestamp);
      }
    }
    return pagestamps4Rubric;
  }

  private loadRequiredData(workflow?: any) {
    this.loadTemplateInfo(workflow);
  }

  private loadTemplateInfo(workflow?: any) {
    this.loading = true;
    this.workflowService.getTemplateDesignBy(this.workflowReceived.id).subscribe(next => {
      this.loading = false;
      this.templateDesignWorkflow = next;
      if (Constant.PREVIEW_OPTION === this.optSelected) {
        if (workflow) {
          this.openPreviewTemplateModal(workflow);
        }
      }
      if (this.isNewTemplate) {
        /*this.addRowLegend();
        this.addRowImage();
        this.addRowQrcode();*/
      } else {
        this.loadLegendRows();
        this.loadImageRows();
        this.loadQrcodeRows();
        this.loadTestfile();
        this.loadDatetimeRows();
        this.loadLayoutfile();
        this.loadRubricRows();
      }
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.TEMPLATE-DESIGN'));
    });
  }

  private createForm() {
    this.designerForm = this.formBuilder.group(
      {
        testFileId: [''],
        testFileBase64: ['', []],
        testFileLength: [''],
        testFilename: [''],
        testFilename2Show: [''],
        arrayLegend: this.formBuilder.array([]),
        arrayImage: this.formBuilder.array([]),
        arrayQrcode: this.formBuilder.array([]),
        arrayDatetime: this.formBuilder.array([]),
        arrayRubricParticipant: this.formBuilder.array([]),
        layoutFileId: [''],
        layoutFileBase64: ['', []],
        layoutFilename: [''],
        layoutFilename2Show: [''],
        layoutFileLength: [''],
        excelLayoutFileBase64: ['', []],
        excelLayoutFilename: [''],
        excelLayoutFilename2Show: [''],
        excelLayoutFileLength: ['']
      });
  }

  public addRowLegend() {
    const group = this.formBuilder.group({
      id: ['', []],
      descriptionLegend: ['', [Validators.required]],
      positionXLegend: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,4}')])],
      positionYLegend: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,4}')])],
      rotationLegend: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      fontsize: [this.fontsizes[Constant.ZERO_INDEX]],
      fonttype: [this.fonttypes[Constant.ZERO_INDEX]],
      fontRgbColor: ['rgba(0,0,0,1)'],
      pagestampLegend: [this.pagestamps[Constant.ZERO_INDEX]],
      stampOnLegend: ['', []],
      active: [Constant.ACTIVE, []]
    });
    this.arrayLegend.push(group);
  }

  private loadLegendRows() {
    this.arrayLegend.clear();
    this.deletedStamplegends = [];
    if (this.templateDesignWorkflow.stamplegends) {
      for (const stamplegend of this.templateDesignWorkflow.stamplegends) {
        const group = this.formBuilder.group({
          id: [stamplegend.id],
          descriptionLegend: [stamplegend.description, [Validators.required]],
          positionXLegend: [stamplegend.positionX, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,4}')])],
          positionYLegend: [stamplegend.positionY, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,4}')])],
          rotationLegend: [stamplegend.rotation, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])],
          fontsize: [this.getFontsize(stamplegend.fontSize)],
          fonttype: [this.getFonttype(stamplegend.fontType)],
          fontRgbColor: [stamplegend.fontRgbColor],
          pagestampLegend: [this.getPagestampOf(stamplegend.pageStamp)],
          stampOnLegend: [stamplegend.stampOn, [!this.necessary2EnterValue(stamplegend.pageStamp) ? Validators.nullValidator : Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])]],
          active: [stamplegend.active]
        });
        this.arrayLegend.push(group);
      }
    }
  }

  get arrayLegend() {
    return this.designerForm.get('arrayLegend') as FormArray;
  }

  public deleteLegendRow(index: number) {
    const rawValue: any = this.arrayLegend.getRawValue()[index];
    if (rawValue.id) {
      const stamplegend = new Stamplegend();
      stamplegend.id = rawValue.id;
      stamplegend.active = Constant.INACTIVE;
      this.deletedStamplegends.push(stamplegend);
    }
    this.arrayLegend.removeAt(index);
  }

  public save() {
    if (this.arrayLegend.invalid) {
      this.markAsTouchedArray(this.arrayLegend);
    }
    if (this.arrayImage.invalid) {
      this.markAsTouchedArray(this.arrayImage);
    }
    if (this.arrayQrcode.invalid) {
      this.markAsTouchedArray(this.arrayQrcode);
    }
    if (this.arrayDatetime.invalid) {
      this.markAsTouchedArray(this.arrayDatetime);
    }
    if (this.arrayRubricParticipant.invalid) {
      this.markAsTouchedArray(this.arrayRubricParticipant);
    }
    if (this.arrayLegend.invalid || this.arrayImage.invalid || this.arrayQrcode.invalid || this.arrayDatetime.invalid || this.arrayRubricParticipant.invalid) {
      return;
    }
    this.optSelected = Constant.SAVE_OPTION;
    this.doSave();
  }

  public markAsTouchedArray(array: FormArray): void {
    for (const group of array.controls) {
      if (group instanceof FormGroup) {
        Object.values(group.controls).forEach(control => {
          control.markAsTouched();
        });
      }
    }
  }

  public doSave() {
    this.setValuesBefore2Save();
    if (this.isNewTemplate) {
      this.register();
    } else {
      this.edit();
    }
  }

  private register() {
    this.loading = true;
    this.workflowService.saveTemplateDesign(this.templateDesignWorkflow).subscribe(next => {
      this.loading = false;
      if (Constant.PREVIEW_OPTION === this.optSelected) {
        this.loadRequiredData(next);
      } else {
        this.activeModal.close(InformType.Success);
      }
    }, () => {
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  public onChangeStamp(group: AbstractControl, callerControlName: string, calledControlName: string) {
    const pageStamp = group.get(callerControlName).value;
    const stampOn = group.get(calledControlName);
    if (this.necessary2EnterValue(pageStamp.id)) {
      stampOn.setValidators(Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')]));
    } else {
      stampOn.reset();
      stampOn.clearValidators();
    }
    stampOn.updateValueAndValidity();
  }

  public optionSelectedBy(group: AbstractControl, callerControlName: string) {
    const stampOnId = group.get(callerControlName).value.id;
    return this.necessary2EnterValue(stampOnId);
  }

  private edit() {
    this.loading = true;
    this.workflowService.updateTemplateDesign(this.templateDesignWorkflow).subscribe(next => {
      this.loading = false;
      if (Constant.PREVIEW_OPTION === this.optSelected) {
        this.loadRequiredData(next);
        // this.openPreviewTemplateModal(next);
      } else {
        this.activeModal.close(InformType.Success);
      }
    }, () => {
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  private setValuesBefore2Save() {
    this.templateDesignWorkflow.workflowId = this.workflowReceived.id;
    // Prepare legends
    const stamplegends: Stamplegend[] = [];
    for (const group of this.arrayLegend.controls) {
      if (group instanceof FormGroup) {
        const stamplegend = new Stamplegend();
        stamplegend.id = group.value.id === '' ? undefined : group.value.id;
        stamplegend.description = group.value.descriptionLegend;
        stamplegend.positionX = group.value.positionXLegend;
        stamplegend.positionY = group.value.positionYLegend;
        stamplegend.rotation = group.value.rotationLegend;
        stamplegend.fontSize = group.value.fontsize.id;
        stamplegend.fontType = group.value.fonttype.id;
        stamplegend.fontRgbColor = group.value.fontRgbColor;
        stamplegend.pageStamp = group.value.pagestampLegend.id;
        stamplegend.stampOn = group.value.stampOnLegend;
        stamplegend.active = group.value.active;
        stamplegends.push(stamplegend);
      }
    }
    this.templateDesignWorkflow.stamplegends = stamplegends;
    this.addDeletedStamlegends();
    // Prepare images
    const stampimages: Stampimage[] = [];
    for (const group of this.arrayImage.controls) {
      if (group instanceof FormGroup) {
        const image = document.getElementById('inputImage');
        this.renderer.setStyle(
          image,
          'transform',
          `rotate(${group.value.rotationImage}deg)`);
        const stampimage = new Stampimage();
        stampimage.id = group.value.id === '' ? undefined : group.value.id;
        stampimage.name = group.value.filenameImage;
        stampimage.positionX = group.value.positionXImage;
        stampimage.positionY = group.value.positionYImage;
        stampimage.percentSize = group.value.percentSizeImage;
        stampimage.rotation = group.value.rotationImage;
        stampimage.contentPosition = group.value.contentpositionImage.id;
        stampimage.pageStamp = group.value.pagestampImage.id;
        stampimage.stampOn = group.value.stampOnImage;
        stampimage.base64Data = group.value.fileBase64Image;
        stampimage.active = group.value.active;
        stampimages.push(stampimage);
      }
    }
    this.templateDesignWorkflow.stampimages = stampimages;
    this.addDeletedStamimages();
    // Prepare qrcodes
    const stampqrcodes: Stampqrcode[] = [];
    for (const group of this.arrayQrcode.controls) {
      if (group instanceof FormGroup) {
        const stampqrcode = new Stampqrcode();
        stampqrcode.id = group.value.id === '' ? undefined : group.value.id;
        stampqrcode.positionX = group.value.positionXQrcode;
        stampqrcode.positionY = group.value.positionYQrcode;
        stampqrcode.sideSize = group.value.sideSizeQrcode;
        stampqrcode.pageStamp = group.value.pagestampQrcode.id;
        stampqrcode.stampOn = group.value.stampOnQrcode;
        stampqrcode.active = group.value.active;
        stampqrcodes.push(stampqrcode);
      }
    }
    this.templateDesignWorkflow.stampqrcodes = stampqrcodes;
    this.addDeletedStamqrcodes();
    // Prepare test file
    const stamptestfile = new Stamptestfile();
    stamptestfile.id = this.designerForm.get('testFileId').value;
    stamptestfile.name = this.designerForm.get('testFilename').value;
    stamptestfile.base64Data = this.designerForm.get('testFileBase64').value;
    stamptestfile.length = this.designerForm.get('testFileLength').value;
    this.templateDesignWorkflow.stamptestfile = stamptestfile.name !== '' ? stamptestfile : null;
    // Prepare legends
    const stampdatetimes: Stampdatetime[] = [];
    for (const group of this.arrayDatetime.controls) {
      if (group instanceof FormGroup) {
        const stampdatetime = new Stampdatetime();
        stampdatetime.id = group.value.id === '' ? undefined : group.value.id;
        stampdatetime.description = group.value.descriptionDatetime;
        stampdatetime.positionX = group.value.positionXDatetime;
        stampdatetime.positionY = group.value.positionYDatetime;
        stampdatetime.widthContainer = group.value.widthContainerDatetime;
        stampdatetime.heightContainer = group.value.heightContainerDatetime;
        stampdatetime.pageStamp = group.value.pagestampDatetime.id;
        stampdatetime.stampOn = group.value.stampOnDatetime;
        stampdatetime.active = group.value.active;
        stampdatetimes.push(stampdatetime);
      }
    }
    this.templateDesignWorkflow.stampdatetimes = stampdatetimes;
    // Prepare stmamprubrics
    const stamprubrics: Stamprubric[] = [];
    for (const group of this.arrayRubricParticipant.controls) {
      if (group instanceof FormGroup) {
        const stamprubric = new Stamprubric();
        stamprubric.id = group.value.id === '' ? undefined : group.value.id;
        stamprubric.participantId = group.value.participantId;
        stamprubric.positionX = group.value.positionXRubric;
        stamprubric.positionY = group.value.positionYRubric;
        stamprubric.positionXf = group.value.positionXfRubric;
        stamprubric.positionYf = group.value.positionYfRubric;
        stamprubric.percentSize = group.value.percentSizeRubric;
        stamprubric.rotation = group.value.rotationRubric;
        stamprubric.contentPosition = group.value.contentpositionRubric.id;
        stamprubric.pageStamp = group.value.pagestampRubric.id;
        stamprubric.stampOn = group.value.stampOnRubric;
        stamprubric.isOriginal = group.value.isOriginal;
        stamprubric.active = group.value.active;
        stamprubrics.push(stamprubric);
      }
    }
    this.templateDesignWorkflow.stamprubrics = stamprubrics;
    this.addDeletedStamprubrics();
    // Prepare test file
    const stamplayoutfile = new Stamplayoutfile();
    stamplayoutfile.id = this.designerForm.get('layoutFileId').value;
    stamplayoutfile.name = this.designerForm.get('layoutFilename').value;
    stamplayoutfile.base64Data = this.designerForm.get('layoutFileBase64').value;
    stamplayoutfile.length = this.designerForm.get('layoutFileLength').value;
    stamplayoutfile.excelName = this.designerForm.get('excelLayoutFilename').value;
    stamplayoutfile.excelBase64Data = this.designerForm.get('excelLayoutFileBase64').value;
    stamplayoutfile.excelLength = this.designerForm.get('excelLayoutFileLength').value;
    this.templateDesignWorkflow.stamplayoutfile = stamplayoutfile.name !== '' ? stamplayoutfile : null;
    this.addDeletedStampdatetimes();
  }

  public cancel() {
    this.activeModal.close(TemplateDesignWorkflowComponent);
  }

  get isNewTemplate(): boolean {
    if (this.templateDesignWorkflow.stamplegends) {
      if (this.templateDesignWorkflow.stamplegends.length === 0 &&
        this.templateDesignWorkflow.stampimages.length === 0 &&
        this.templateDesignWorkflow.stampqrcodes.length === 0 &&
        this.templateDesignWorkflow.stampdatetimes.length === 0 &&
        this.templateDesignWorkflow.stamptestfile === undefined &&
        this.templateDesignWorkflow.stamplayoutfile === undefined &&
        this.templateDesignWorkflow.stamprubrics.length === 0) {
        return true;
      } else {
        return !this.existSomeRegisteredStamplegened
          && !this.existSomeRegisteredStampimage
          && !this.existSomeRegisteredStampqrcode
          && !this.existSomeRegisteredFiletest
          && !this.existSomeRegisteredStampdatetime
          && !this.existSomeRegisteredFilelayout
          && !this.existSomeRegisteredStamprubric;
      }
    } else {
      return true;
    }
  }

  get existSomeRegisteredStamplegened(): boolean {
    return !(this.templateDesignWorkflow.stamplegends.find(stamplegend => stamplegend.id !== undefined) === undefined);
  }

  get existSomeRegisteredStampimage(): boolean {
    return !(this.templateDesignWorkflow.stampimages.find(stampimage => stampimage.id !== undefined) === undefined);
  }

  get existSomeRegisteredStampqrcode(): boolean {
    return !(this.templateDesignWorkflow.stampqrcodes.find(stampqrcode => stampqrcode.id !== undefined) === undefined);
  }

  get existSomeRegisteredStampdatetime(): boolean {
    return !(this.templateDesignWorkflow.stampdatetimes.find(stampdatetime => stampdatetime.id !== undefined) === undefined);
  }

  get existSomeRegisteredFiletest(): boolean {
    if (this.templateDesignWorkflow.stamptestfile) {
      return !(this.templateDesignWorkflow.stamptestfile.name === '');
    }
    return false;
  }

  get existSomeRegisteredFilelayout(): boolean {
    if (this.templateDesignWorkflow.stamplayoutfile) {
      return !(this.templateDesignWorkflow.stamplayoutfile.name === '');
    }
    return false;
  }

  get existSomeRegisteredStamprubric(): boolean {
    return !(this.templateDesignWorkflow.stamprubrics.find(stamprubric => stamprubric.id !== undefined) === undefined);
  }

  private getFontsize(fontsizeId: number): Fontsize {
    return this.fontsizes.find(fontsize => fontsize.id === fontsizeId);
  }

  private getFonttype(fonttypeId: number): Fonttype {
    return this.fonttypes.find(fonttype => fonttype.id === fonttypeId);
  }

  private getPagestampOf(pagestampId: number): Pagestamp {
    return this.pagestamps.find(pagestamp => pagestamp.id === pagestampId);
  }

  private getSelectedPagestampBy(participant: Participant, pagestampId: number): Pagestamp {
    if (TypeSignature.CLOUD === participant.typeSignature || participant.dragRubric) {
      return this.pagestamps4Cloud.find(pagestamp => pagestamp.id === pagestampId);
    } else {
      return this.pagestamps.find(pagestamp => pagestamp.id === pagestampId);
    }
  }

  private getPagestamp4DatetimeOf(pagestampId: number): Fonttype {
    return this.pagestamps4Datetime.find(pagestamp => pagestamp.id === pagestampId);
  }

  private getContentpositionOf(contentpositionId: number): Fonttype {
    return this.contentpositions.find(contentposition => contentposition.id === contentpositionId);
  }

  private addDeletedStamlegends() {
    this.deletedStamplegends.forEach(stamplegend => this.templateDesignWorkflow.stamplegends.push(stamplegend));
  }

  get arrayImage() {
    return this.designerForm.get('arrayImage') as FormArray;
  }

  public addRowImage() {
    const group = this.formBuilder.group({
      id: ['', []],
      fileBase64Image: ['', [Validators.required]],
      filenameImage: [''],
      filename2ShowImage: [''],
      positionXImage: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,4}')])],
      positionYImage: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,4}')])],
      percentSizeImage: ['', Validators.compose([Validators.required,
        Validators.pattern('^\\d{1,3}(\\.\\d{1,3})?$')])],
      rotationImage: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      contentpositionImage: [this.contentpositions[Constant.ZERO_INDEX]],
      pagestampImage: [this.pagestamps[Constant.ZERO_INDEX]],
      stampOnImage: [''],
      active: [Constant.ACTIVE, []]
    });
    this.arrayImage.push(group);
  }

  isInvalid(group: AbstractControl, control: string): boolean {
    if (group.get(control)) {
      return group.get(control).invalid && group.get(control).touched;
    }
    return false;
  }

  public changeStatus(event: any, index: number) {
    const fileImage: any = event[Constant.ZERO_INDEX];
    const group = this.arrayImage.at(index);
    if (fileImage) {
      group.patchValue({
        fileBase64Image: fileImage.base64,
        filenameImage: fileImage.name,
        filename2ShowImage: StringUtil.cut(fileImage.name, 42, this.translate.instant('MESSAGE.SELECT')),
      });
    } else {
      const validatefileBase64Image = group.get('filename2ShowImage');
      if (validatefileBase64Image) {
        validatefileBase64Image.markAsTouched();
      }
    }
    const fileBase64Image = group.get('filename2ShowImage');
    if (fileBase64Image) {
      fileBase64Image.updateValueAndValidity();
    }
  }

  public changeStatus2(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.designerForm.patchValue({
      testFileLength: testFile.size,
      testFileBase64: testFile.base64,
      testFilename: testFile.name,
      testFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.designerForm.get('testFileBase64').updateValueAndValidity();
  }

  public changeStatus3(event: any) {
    const layoutFile = event[Constant.ZERO_INDEX];
    this.designerForm.patchValue({
      layoutFileBase64: layoutFile.base64,
      layoutFilename: layoutFile.name,
      layoutFileLength: layoutFile.size,
      layoutFilename2Show: StringUtil.cut(layoutFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.designerForm.get('layoutFileBase64').updateValueAndValidity();
  }

  public changeStatus4(event: any) {
    const excelLayoutFile = event[Constant.ZERO_INDEX];
    this.designerForm.patchValue({
      excelLayoutFileBase64: excelLayoutFile.base64,
      excelLayoutFilename: excelLayoutFile.name,
      excelLayoutFileLength: excelLayoutFile.size,
      excelLayoutFilename2Show: StringUtil.cut(excelLayoutFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.designerForm.get('excelLayoutFileBase64').updateValueAndValidity();
  }

  private loadImageRows() {
    this.arrayImage.clear();
    this.deletedStampimages = [];
    if (this.templateDesignWorkflow.stampimages) {
      for (const stampimage of this.templateDesignWorkflow.stampimages) {
        const group = this.formBuilder.group({
          id: [stampimage.id],
          fileBase64Image: undefined,
          filenameImage: undefined,
          filename2ShowImage: [StringUtil.cut(stampimage.name, 42, this.translate.instant('MESSAGE.SELECT')), [Validators.required]],
          positionXImage: [stampimage.positionX, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,4}')])],
          positionYImage: [stampimage.positionY, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,4}')])],
          percentSizeImage: [stampimage.percentSize, Validators.compose([Validators.required,
            Validators.pattern('^\\d{1,3}(\\.\\d{1,3})?$')])],
          rotationImage: [stampimage.rotation, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])],
          contentpositionImage: [this.getContentpositionOf(stampimage.contentPosition)],
          pagestampImage: [this.getPagestampOf(stampimage.pageStamp)],
          stampOnImage: [stampimage.stampOn, [!this.necessary2EnterValue(stampimage.pageStamp) ? Validators.nullValidator :
            Validators.compose([Validators.required, Validators.pattern('^[0-9]{1,3}')])]],
          active: [stampimage.active]
        });
        this.arrayImage.push(group);
      }
    }
  }

  private loadRubricRows() {
    this.arrayRubricParticipant.clear();
    this.deletedStamprubrics = [];
    if (this.templateDesignWorkflow.stamprubrics) {
      for (const stamprubric of this.templateDesignWorkflow.stamprubrics) {
        const group = this.formBuilder.group({
          id: [stamprubric.id],
          participantId: [stamprubric.participantId],
          positionXRubric: [stamprubric.positionX, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,4}')])],
          positionYRubric: [stamprubric.positionY, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,4}')])],
          positionXfRubric: [stamprubric.positionXf, [stamprubric.participantByParticipantId.personId === Constant.DEFAULT_PERSON_ID ? Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,4}')]) : Validators.nullValidator]],
          positionYfRubric: [stamprubric.positionYf, [stamprubric.participantByParticipantId.personId === Constant.DEFAULT_PERSON_ID ? Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,4}')]) : Validators.nullValidator]],
          percentSizeRubric: [stamprubric.percentSize, [stamprubric.participantByParticipantId.personId === Constant.DEFAULT_PERSON_ID ? Validators.nullValidator : Validators.compose([Validators.required,
            Validators.pattern('^\\d{1,3}(\\.\\d{1,3})?$')])]],
          rotationRubric: [stamprubric.rotation, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])],
          contentpositionRubric: [this.getContentpositionOf(stamprubric.contentPosition)],
          pagestampRubric: [this.getSelectedPagestampBy(stamprubric.participantByParticipantId, stamprubric.pageStamp)],
          stampOnRubric: [stamprubric.stampOn, [!this.necessary2EnterValue(stamprubric.pageStamp) ? Validators.nullValidator :
            Validators.compose([Validators.required, Validators.pattern('^[0-9]{1,3}')])]],
          isOriginal: [stamprubric.isOriginal],
          active: [stamprubric.active],
          personId: [stamprubric.participantByParticipantId.personId],
        });
        this.arrayRubricParticipant.push(group);
      }
    }
  }

  public necessary2EnterValue(pagestampId: number): boolean {
    return Constant.OTHER_PAGESTAMP === pagestampId || Constant.SINCE_PAGESTAMP === pagestampId || Constant.UNTIL_PAGESTAMP === pagestampId;
  }

  public deleteImageRow(index: number) {
    const rawValue: any = this.arrayImage.getRawValue()[index];
    if (rawValue.id) {
      const stampimage = new Stampimage();
      stampimage.id = rawValue.id;
      stampimage.active = Constant.INACTIVE;
      this.deletedStampimages.push(stampimage);
    }
    this.arrayImage.removeAt(index);
  }

  private addDeletedStamimages() {
    this.deletedStampimages.forEach(stampimage => this.templateDesignWorkflow.stampimages.push(stampimage));
  }

  // For QR codes
  get arrayQrcode() {
    return this.designerForm.get('arrayQrcode') as FormArray;
  }

  public addRowQrcode() {
    const group = this.formBuilder.group({
      id: ['', []],
      positionXQrcode: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      positionYQrcode: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      sideSizeQrcode: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      pagestampQrcode: [this.pagestamps[Constant.ZERO_INDEX]],
      stampOnQrcode: [''],
      active: [Constant.ACTIVE, []]
    });
    this.arrayQrcode.push(group);
  }

  public deleteQrcodeRow(index: number) {
    const rawValue: any = this.arrayQrcode.getRawValue()[index];
    if (rawValue.id) {
      const stampqrcode = new Stampqrcode();
      stampqrcode.id = rawValue.id;
      stampqrcode.active = Constant.INACTIVE;
      this.deletedStampqrcodes.push(stampqrcode);
    }
    this.arrayQrcode.removeAt(index);
  }

  private addDeletedStamqrcodes() {
    this.deletedStampqrcodes.forEach(stampqrcode => this.templateDesignWorkflow.stampqrcodes.push(stampqrcode));
  }

  private loadQrcodeRows() {
    this.arrayQrcode.clear();
    this.deletedStampqrcodes = [];
    if (this.templateDesignWorkflow.stampqrcodes) {
      for (const stampqrcode of this.templateDesignWorkflow.stampqrcodes) {
        const group = this.formBuilder.group({
          id: [stampqrcode.id],
          positionXQrcode: [stampqrcode.positionX, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])],
          positionYQrcode: [stampqrcode.positionY, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])],
          sideSizeQrcode: [stampqrcode.sideSize, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])],
          pagestampQrcode: [this.getPagestampOf(stampqrcode.pageStamp)],
          stampOnQrcode: [stampqrcode.stampOn, [!this.necessary2EnterValue(stampqrcode.pageStamp) ? Validators.nullValidator : Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])]],
          active: [stampqrcode.active]
        });
        this.arrayQrcode.push(group);
      }
    }
  }

  /**
   * Procedimiento del método previsualizar: es necesario en primer lugar registrar
   * todas las modificaciones que pudieron generarse, las obtiene, posteriormente limpia
   * las listas antiguas y reemplaza los ítems con los nuevos. Finalmente con la respuesta
   * anterior abre de diálogo y previsualiza el documento.
   */
  public preview() {
    if (this.arrayLegend.invalid) {
      this.markAsTouchedArray(this.arrayLegend);
    }
    if (this.arrayImage.invalid) {
      this.markAsTouchedArray(this.arrayImage);
    }
    if (this.arrayQrcode.invalid) {
      this.markAsTouchedArray(this.arrayQrcode);
    }
    if (this.arrayDatetime.invalid) {
      this.markAsTouchedArray(this.arrayDatetime);
    }
    if (this.arrayRubricParticipant.invalid) {
      this.markAsTouchedArray(this.arrayRubricParticipant);
    }
    if (this.arrayLegend.invalid || this.arrayImage.invalid || this.arrayQrcode.invalid || this.arrayDatetime.invalid || this.arrayRubricParticipant.invalid) {
      return;
    }
    this.optSelected = Constant.PREVIEW_OPTION;
    this.doSave();
  }

  private openPreviewTemplateModal(workflow: any) {
    this.entityName = this.translate.instant('TITLE.TEMPLATE-DESIGN');
    const modalRef = this.modalService.open(PreviewTemplateWorkflowComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.workflowReceived = workflow;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.activeModal.close(InformType.Success);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      } else if (InformType.Anything === result) {
        this.activeModal.close(TemplateDesignWorkflowComponent);
      }
    });
  }

  private loadTestfile() {
    if (this.templateDesignWorkflow.stamptestfile) {
      const stamptestfile = this.templateDesignWorkflow.stamptestfile;
      this.designerForm.patchValue({
        testFileId: stamptestfile.id,
        testFilename: stamptestfile.name,
        testFileLength: stamptestfile.length,
        testFilename2Show: StringUtil.cut(stamptestfile.name, 42, this.translate.instant('MESSAGE.SELECT'))
      });
    }
  }

  private loadLayoutfile() {
    if (this.templateDesignWorkflow.stamplayoutfile) {
      const stamplayoutfile = this.templateDesignWorkflow.stamplayoutfile;
      this.designerForm.patchValue({
        layoutFileId: stamplayoutfile.id,
        layoutFilename: stamplayoutfile.name,
        layoutFileLength: stamplayoutfile.length,
        layoutFilename2Show: StringUtil.cut(stamplayoutfile.name, 42, this.translate.instant('MESSAGE.SELECT')),
        excelLayoutFilename: stamplayoutfile.excelName,
        excelLayoutFilename2Show: StringUtil.cut(stamplayoutfile.excelName, 42, this.translate.instant('MESSAGE.SELECT')),
        excelLayoutFileLength: stamplayoutfile.excelLength
      });
    }
  }

  get arrayDatetime() {
    return this.designerForm.get('arrayDatetime') as FormArray;
  }

  public addRowDatetime() {
    const group = this.formBuilder.group({
      id: ['', []],
      descriptionDatetime: ['<DATE>', [Validators.required]],
      positionXDatetime: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      positionYDatetime: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      widthContainerDatetime: ['100', Validators.compose([Validators.required,
        Validators.pattern('^([2-9][0-9]|[1-9][0-9]{2}|999)$')])],
      heightContainerDatetime: ['50', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      pagestampDatetime: [this.pagestamps4Datetime[Constant.ZERO_INDEX]],
      stampOnDatetime: [''],
      active: [Constant.ACTIVE, []]
    });
    this.arrayDatetime.push(group);
  }

  public deleteDatetimeRow(index: number) {
    const rawValue: any = this.arrayDatetime.getRawValue()[index];
    if (rawValue.id) {
      const stampdatetime = new Stampdatetime();
      stampdatetime.id = rawValue.id;
      stampdatetime.active = Constant.INACTIVE;
      this.deletedStampdatetimes.push(stampdatetime);
    }
    this.arrayDatetime.removeAt(index);
  }

  private addDeletedStampdatetimes() {
    this.deletedStampdatetimes.forEach(deletedStampdatetime => this.templateDesignWorkflow.stampdatetimes.push(deletedStampdatetime));
  }

  private loadDatetimeRows() {
    this.arrayDatetime.clear();
    this.deletedStampdatetimes = [];
    if (this.templateDesignWorkflow.stampdatetimes) {
      for (const stampdatetime of this.templateDesignWorkflow.stampdatetimes) {
        const group = this.formBuilder.group({
          id: [stampdatetime.id],
          descriptionDatetime: [stampdatetime.description, [Validators.required]],
          positionXDatetime: [stampdatetime.positionX, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])],
          positionYDatetime: [stampdatetime.positionY, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])],
          widthContainerDatetime: [stampdatetime.widthContainer, Validators.compose([Validators.required,
            Validators.pattern('^([2-9][0-9]|[1-9][0-9]{2}|999)$')])],
          heightContainerDatetime: [stampdatetime.heightContainer, Validators.compose([Validators.required,
            Validators.pattern('^[0-9]{1,3}')])],
          pagestampDatetime: [this.getPagestamp4DatetimeOf(stampdatetime.pageStamp)],
          stampOnDatetime: [stampdatetime.stampOn, [!this.necessary2EnterValue(stampdatetime.pageStamp) ?
            Validators.nullValidator : Validators.compose([Validators.required, Validators.pattern('^[0-9]{1,3}')])]],
          active: [stampdatetime.active]
        });
        this.arrayDatetime.push(group);
      }
    }
  }

  get requireJasperTemplate(): boolean {
    return this.workflowReceived.type === WorkflowType.SIGNATURE_AND_NOTIFICATION_WITH_TEMPLATE ||
      (this.workflowReceived.type === WorkflowType.UPLOAD_TO_IOFESIGN && this.workflowReceived.xmlAsDatasource);
  }

  get arrayRubricParticipant() {
    return this.designerForm.get('arrayRubricParticipant') as FormArray;
  }

  public addRowRubricParticipant() {
    let participant: Participant = null;
    let participantFound = false;
    this.participants.forEach(participant1 => {
      const stampRubrics = this.arrayRubricParticipant.value.filter(arrayValue => arrayValue.participantId === participant1.id && arrayValue.isOriginal === TypeStampRubric.ORIGINAL).length;
      if (stampRubrics === 0 && !participantFound) {
        participant = participant1;
        participantFound = true;
      }
    });
    const group = this.formBuilder.group({
      id: ['', []],
      participantId: [participant.id],
      positionXRubric: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      positionYRubric: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      positionXfRubric: ['', [participant.personId === Constant.DEFAULT_PERSON_ID ? Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')]) : Validators.nullValidator]],
      positionYfRubric: ['', [participant.personId === Constant.DEFAULT_PERSON_ID ? Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')]) : Validators.nullValidator]],
      percentSizeRubric: ['', [participant.personId === Constant.DEFAULT_PERSON_ID ? Validators.nullValidator : Validators.compose([Validators.required,
        Validators.pattern('^\\d{1,3}(\\.\\d{1,3})?$')])]],
      rotationRubric: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      contentpositionRubric: [this.contentpositions[Constant.ZERO_INDEX]],
      pagestampRubric: this.getPagestampBy(participant.typeSignature, participant.dragRubric),
      stampOnRubric: ['', [!this.necessary2EnterValue(this.getPagestampBy(participant.typeSignature, participant.dragRubric).id) ?
        Validators.nullValidator : Validators.compose([Validators.required, Validators.pattern('^[0-9]{1,3}')])]],
      active: [Constant.ACTIVE, []],
      personId: [participant.personId],
      isOriginal: [TypeStampRubric.ORIGINAL, []],
    });
    this.arrayRubricParticipant.push(group);
  }

  public addRowRubricParticipant1(index: number) {
    const rawValue: any = this.arrayRubricParticipant.getRawValue()[index];
    const index1 = this.participants.findIndex(participant => rawValue.participantId === participant.id);
    const newIndex = this.arrayRubricParticipant.value.filter(rawRubric => rawRubric.isOriginal !== TypeStampRubric.ORIGINAL && rawRubric.participantId === rawValue.participantId).length + 1;
    const group = this.formBuilder.group({
      id: ['', []],
      participantId: [this.participants[index1].id],
      positionXRubric: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      positionYRubric: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      positionXfRubric: ['', [this.participants[index1].personId === Constant.DEFAULT_PERSON_ID ? Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')]) : Validators.nullValidator]],
      positionYfRubric: ['', [this.participants[index1].personId === Constant.DEFAULT_PERSON_ID ? Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')]) : Validators.nullValidator]],
      percentSizeRubric: ['', [this.participants[index1].personId === Constant.DEFAULT_PERSON_ID ? Validators.nullValidator : Validators.compose([Validators.required,
        Validators.pattern('^\\d{1,3}(\\.\\d{1,3})?$')])]],
      rotationRubric: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')])],
      contentpositionRubric: [this.contentpositions[index1]],
      pagestampRubric: this.getPagestampBy(this.participants[index1].typeSignature, this.participants[index1].dragRubric),
      stampOnRubric: ['', [!this.necessary2EnterValue(this.getPagestampBy(this.participants[index1].typeSignature, this.participants[index1].dragRubric).id) ?
        Validators.nullValidator : Validators.compose([Validators.required, Validators.pattern('^[0-9]{1,3}')])]],
      active: [Constant.ACTIVE, []],
      personId: [this.participants[index1].personId],
      isOriginal: [TypeStampRubric.COPY, []],
    });
    this.arrayRubricParticipant.insert(index + newIndex, group);
  }

  public isOriginalParticipant(index: number) {
    const rawValue: any = this.arrayRubricParticipant.getRawValue()[index];
    return rawValue.isOriginal === TypeStampRubric.COPY;
  }

  public isSignCloud(index: number) {
    const rawValue: any = this.arrayRubricParticipant.getRawValue()[index];
    const participant1: Participant = this.participants.find(participant => rawValue.participantId === participant.id);
    return TypeSignature.CLOUD === participant1.typeSignature;
  }

  public hasDragRubric(index: number) {
    const rawValue: any = this.arrayRubricParticipant.getRawValue()[index];
    const participant1: Participant = this.participants.find(participant => rawValue.participantId === participant.id);
    return participant1.dragRubric;
  }

  public hasStampRubricsCopy(index: number) {
    const raw: any = this.arrayRubricParticipant.getRawValue()[index];
    if (raw.isOriginal) {
      return this.arrayRubricParticipant.value.filter(rawValue => rawValue.participantId === raw.participantId && rawValue.isOriginal === TypeStampRubric.COPY).length > 0;
    } else {
      return false;
    }
  }

  private getPagestampBy(typeSignature: number, dragRubric: boolean): Pagestamp {
    if (TypeSignature.CLOUD === typeSignature || dragRubric) {
      return this.pagestamps4Cloud[Constant.ZERO_INDEX];
    } else {
      return this.pagestamps[Constant.ZERO_INDEX];
    }
  }

  get participantsIsFull() {
    return this.participants.length !== 0 && this.participants.length <= this.arrayRubricParticipant.value.filter(rawValue => rawValue.isOriginal === TypeStampRubric.ORIGINAL).length;
  }

  public deleteParticipantRow(index: number) {
    const rawValue: any = this.arrayRubricParticipant.getRawValue()[index];
    if (rawValue.id) {
      const stamprubric = new Stamprubric();
      stamprubric.id = rawValue.id;
      stamprubric.active = Constant.INACTIVE;
      this.deletedStamprubrics.push(stamprubric);
    }
    this.arrayRubricParticipant.removeAt(index);
  }

  public existSeletedParticipant(index: number): boolean {
    const stampRubricValue: any = this.arrayRubricParticipant.getRawValue()[index];
    if (!stampRubricValue.isOriginal) {
      return false;
    } else {
      const counter = this.arrayRubricParticipant.value.filter(rawValue => rawValue.participantId === stampRubricValue.participantId && rawValue.isOriginal === TypeStampRubric.ORIGINAL).length;
      return counter > 1;
    }
  }

  public pendingPersonSelected(group: AbstractControl): boolean {
    const personId = group.get('personId').value;
    return Constant.DEFAULT_PERSON_ID === personId;
  }

  private addDeletedStamprubrics() {
    this.deletedStamprubrics.forEach(stamprubric => this.templateDesignWorkflow.stamprubrics.push(stamprubric));
  }

  colorPickerChange(index: number, rgbColor: string) {
    this.arrayLegend.at(index).get('fontRgbColor').setValue(rgbColor);
  }

  getColor(index: number): string {
    return this.arrayLegend.at(index).get('fontRgbColor').value;
  }

  isParticipantSelected(participantId: number): boolean {
    return this.arrayRubricParticipant.value.filter(rawValue => rawValue.participantId === participantId && rawValue.isOriginal === TypeStampRubric.ORIGINAL).length > 0;
  }

  setUpPersonIdValueAndValidations(group: AbstractControl): void {
    const participantId = group.get('participantId').value;
    const participant = this.participants.find(participant1 => participant1.id === participantId);
    if (participant) {
      if (TypeSignature.CLOUD === participant.typeSignature || participant.dragRubric) {
        group.get('pagestampRubric').setValue(this.pagestamps4Cloud[Constant.ZERO_INDEX]);
      } else {
        group.get('pagestampRubric').setValue(this.pagestamps[Constant.ZERO_INDEX]);
      }
      group.get('personId').setValue(participant.personId);
    }
    const positionXfRubricControl = group.get('positionXfRubric');
    const positionYfRubricControl = group.get('positionYfRubric');
    const percentSizeRubricControl = group.get('percentSizeRubric');
    if (Constant.DEFAULT_PERSON_ID === participant.personId) {
      positionXfRubricControl.setValidators(Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')]));
      positionYfRubricControl.setValidators(Validators.compose([Validators.required,
        Validators.pattern('^[0-9]{1,3}')]));
      percentSizeRubricControl.reset();
      percentSizeRubricControl.clearValidators();
    } else {
      positionXfRubricControl.reset();
      positionYfRubricControl.reset();
      positionXfRubricControl.clearValidators();
      positionYfRubricControl.clearValidators();
      percentSizeRubricControl.setValidators(Validators.compose([Validators.required,
        Validators.pattern('^\\d{1,3}(\\.\\d{1,3})?$')]));
    }
    positionXfRubricControl.updateValueAndValidity();
    positionYfRubricControl.updateValueAndValidity();
    percentSizeRubricControl.updateValueAndValidity();
  }

  get isNotDynamicWorkFlow(): boolean {
    return this.workflowReceived.dynamic !== Constant.DYNAMICALLY;
  }

  /**
   * Verifica si el documento que se va a firmar tiene firmas digitales
   */
  get hasDigitalSignature(): boolean {
    return this.participants.filter(participant => TypeSignature.DIGITAL === participant.typeSignature).length > 0;
  }

  /**
   * Verifica si el documento que se va a firmar tiene firmas con arrastre de rubrica
   */
  get hasParticipantWithDragRubric(): boolean {
    return this.participants.filter(participant => participant.dragRubric).length > 0;
  }

  get extractCoordinates(): boolean {
    return this.workflowReceived.extractCoordinates;
  }

  /**
   * Obtiene la lista de Pagestamp de acuerdo al tipo de firma del participante
   * @param index índice del participante en el array de rúbricas
   */
  getPagestampsBy(index: number): Pagestamp[] {
    const group = this.arrayRubricParticipant.at(index);
    const participantId = group.get('participantId').value;
    const participant = this.participants.find(participant1 => participant1.id === participantId);
    if (participant) {
      return TypeSignature.CLOUD === participant.typeSignature || participant.dragRubric ? this.pagestamps4Cloud : this.pagestamps;
    } else {
      return this.pagestamps;
    }
  }

  viewParams(): void {
    const message = this.translate.instant('MESSAGE.PARAMETERS-ALLOWED-IN-LEGENDS')
      .concat('<ul>')
      .concat('<li><b>${resourceHash}</b>', this.translate.instant('MESSAGE.VERIFICATION-CODE-RESULT'), ': A6arY85Pcl</li>')
      .concat('<li><b>${date}</b>', this.translate.instant('MESSAGE.DATE-RESULT'), ': 15/12/2021</li>')
      .concat('<li><b>${time}</b>', this.translate.instant('MESSAGE.TIME-RESULT'), ': 14:28:31</li>')
      .concat('<li><b>${datetime}</b>', this.translate.instant('MESSAGE.DATE-AND-TIME-RESULT'), ': 15/12/2021 14:28:31</li>')
      .concat('<li><b>${sequentialNumber}</b>', ' Número secuencial. Resultado', ': 000001 (Configuración disponible previa configuración en el flujo)</li>')
      .concat('</ul>');
    Dialog.show(InformType.Info, this.translate.instant('TITLE.PARAMETERS-IN-LEGENDS'), message);
  }
}
